import * as angular from 'angular';
import * as _ from 'lodash';

import { IDigitalSetService } from '../../services';
import { DigitalSet } from '../../models';
import { Store } from '../Store';
import * as DIGITALSETS from './digitalSets.constants';
import * as Actions from './digitalSets.actions';

export interface IDigitalSetActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalSet>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalSet[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalSet[]>;
    updateOne(target: DigitalSet): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalSet[]>;
    deleteOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<DigitalSet[]>;
}

export class DigitalSetsActionsService implements IDigitalSetActionsService {
    static serviceId = 'digitalSetActionsService';

    static $inject = [
        '$q',
        'digitalSetService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _digitalSetService: IDigitalSetService) {
    }

    getOne(guid: string) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalSets } = getState();
            if (!digitalSets.isLoading && !digitalSets.isLoaded) {
                dispatch(Actions.loadDigitalSets());
                return this._digitalSetService.getAll(true)
                    .then(data => {
                        const result = data.filter(c => c.guid === guid);
                        dispatch(Actions.loadDigitalSetsSuccess(result));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALSETS.DIGITAL_SETS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.find(_.values<DigitalSet>(digitalSets.dictionary), c => c.guid === guid));
            }
        };
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean) {
        return (dispatch: any, getState: () => Store) => {
            const { digitalSets } = getState();
            if (force || (!digitalSets.isLoading && !digitalSets.isLoaded)) {
                dispatch(Actions.loadDigitalSets());
                return this._digitalSetService.getAll(force)
                    .then(data => {
                        dispatch(Actions.loadDigitalSetsSuccess(data));
                        return data;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALSETS.DIGITAL_SETS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalSet>(digitalSets.dictionary));
            }
        };
    }

    addOne(target: DigitalSet) {
        return this.updateOne(target);
    }

    updateOne(target: DigitalSet) {
        const targets = [target];
        return (dispatch: any, getState: () => Store) => {
            const { digitalSets } = getState();
            if (targets && targets.length > 0) {
                dispatch(Actions.updateDigitalSets(targets));
                return this._digitalSetService.addOrUpdate(target)
                    .then(data => {
                        const result = data;
                        dispatch(Actions.updateDigitalSetsSuccess([result]));
                        return _.values<DigitalSet>(getState().digitalSets.dictionary);
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALSETS.DIGITAL_SETS_UPDATE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalSet>(digitalSets.dictionary));
            }
        };
    }

    deleteOne(guid: string) {
        const guids = [guid];
        return (dispatch: any, getState: () => Store) => {
            const { digitalSets } = getState();
            if (guid && guid.length > 0) {
                dispatch(Actions.deleteDigitalSets(guids));
                return this._digitalSetService.deleteDigitalSet(guid)
                    .then(data => {
                        const dic = getState().digitalSets.dictionary;
                        const result = dic[guid];
                        dispatch(Actions.deleteDigitalSetsSuccess([result]));
                        return result;
                    })
                    .catch((reason) => {
                        dispatch({ type: DIGITALSETS.DIGITAL_SETS_DELETE_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values<DigitalSet>(digitalSets.dictionary));
            }
        };
    }
}